module.exports = __webpack_public_path__ + "img/on-line.7a8a2025.png";